import { SVGProps, memo } from 'react';
const ViewsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={props.width || "24"} height={props.height || "25"} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Eye">
      <g id="Icon">
        <path d="M4 12.1162C4 12.1162 6.90909 6.11621 12 6.11621C17.0909 6.11621 20 12.1162 20 12.1162C20 12.1162 17.0909 18.1162 12 18.1162C6.90909 18.1162 4 12.1162 4 12.1162Z" stroke={props.stroke || "#424242"} strokeOpacity={props.strokeOpacity || "0.5"} strokeLinecap={props.strokeLinecap || "round"} strokeLinejoin={props.strokeLinejoin || "round"}/>
        <path d="M12 14.3662C13.205 14.3662 14.1818 13.3589 14.1818 12.1162C14.1818 10.8736 13.205 9.86621 12 9.86621C10.795 9.86621 9.81818 10.8736 9.81818 12.1162C9.81818 13.3589 10.795 14.3662 12 14.3662Z" stroke={props.stroke || "#424242"} strokeOpacity={props.strokeOpacity || "0.5"} strokeLinecap={props.strokeLinecap || "round"} strokeLinejoin={props.strokeLinejoin || "round"}/>
      </g>
    </g>
  </svg>
);

export default memo(ViewsIcon);
